module.exports = __webpack_public_path__ + "static/hackathon-logo-final-af5a3224947eab131cbf23823fec8e5c.png";